import React, {Component} from "react";
import Swiper from "react-id-swiper";

export default class ListMenuUpT extends Component {

  render() {

    let params = {
      breakpoints: {
        576: {
          slidesPerView: 5,
        },
        768: {
          slidesPerView: 11,
        },
      },
      spaceBetween: 9,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev ',
      },
      on: {
        slideChange: function() {
            if (!this.isBeginning) {
              this.navigation.$nextEl.addClass('hide');
            }
          },
        },

      scrollbar: {
        el: '.swiper-scrollbar',
        hide: true,
      }
    };

    return (
      <div
        className={`footer-upt-sp toolbar`}
      >
            <Swiper {...params}>

              <div className="button top-bt-upt substrate-upt" style={{width:'200px'}}>
                <span className="substrateBg">
                </span>
                <span className="label">アイテム変更</span>
              </div>
              <div className="button top-bt-upt" label="表裏袖" type="button">
                <svg className="icon-upt">
                  <use xlinkHref={`#icon-paper`}/>
                </svg>
                <span className="label">表裏袖</span>
              </div>
              <div className="button top-bt-upt" label="カラー変更">
                <span className="color"></span>
                <span className="label">カラー変更</span>
              </div>
              <div className="button top-bt-upt" label="画像アップ" type="button">
                <svg className="icon-upt">
                  <use xlinkHref={`#icon-image`}/>
                </svg>
                <span className="label">画像アップ</span>
              </div>
              <div className="button top-bt-upt" label="テキスト" type="button">
                <svg className="icon-upt">
                  <use xlinkHref={`#icon-text`}/>
                </svg>
                <span className="label">テキスト</span>
              </div>
              <div className="button top-bt-upt" label="レイヤー" type="button">
                <svg className="icon-upt">
                  <use xlinkHref={`#icon-layers`}/>
                </svg>
                <span className="label">レイヤー</span>
              </div>
              <div className="button bottom-bt-upt active" label="画像移動" type="button">
                <svg className="icon-upt">
                  <use xlinkHref={`#icon-cursor`}/>
                </svg>
                <span className="label">画像移動</span>
              </div>
              <div className="button bottom-bt-upt" label="[object Object]" type="button">
                <svg className="icon-upt">
                  <use xlinkHref={`#icon-hand`}/>
                </svg>
                <span className="label">
                  <span>アイテム<br/>位置移動</span>
                </span>
              </div>
              <div className="button bottom-bt-upt" label="シェイプ" type="button">
                <svg className="icon-upt">
                  <use xlinkHref={`#icon-figures`}/>
                </svg>
                <span className="label">シェイプ</span>
              </div>
              <div className="button bottom-bt-upt" label="スタンプ" type="button">
                <svg className="icon-upt">
                  <use xlinkHref={`#icon-sticker`}/>
                </svg>
                <span className="label">スタンプ</span>
              </div>
              <div className="button bottom-bt-upt" label="筆" type="button">
                <svg className="icon-upt">
                  <use xlinkHref={`#icon-brush`}/>
                </svg>
                <span className="label">筆</span>
              </div>
              <div className="button bottom-bt-upt" label="カラー透明化" type="button">
                <svg className="icon-upt">
                  <use xlinkHref={`#icon-opacity`}/>
                </svg>
                <span className="label">カラー透明化</span>
              </div>
              <div className="button bottom-bt-upt" label="全削除" type="button">
                <svg className="icon-upt">
                  <use xlinkHref={`#icon-delete`}/>
                </svg>
                <span className="label">全削除</span></div>
            </Swiper>
      </div>
    );
  }
}
